import standardOpeningHoursTransformer from 'Utils/standardOpeningHoursCMS';

const calculateSchedules = (standardOpeningHours, holidays, contactType) => {
    const standardOpeningHoursByContactType = standardOpeningHours?.items?.find((item) =>
        item?.type?.includes(contactType),
    );

    const holidaysByContactType = holidays?.items?.filter((item) =>
        item?.type?.includes(contactType),
    );

    const hoursCMS = standardOpeningHoursByContactType
        ? standardOpeningHoursTransformer(standardOpeningHoursByContactType, holidaysByContactType)
        : null;

    const afterHoursMessage = hoursCMS ? hoursCMS.afterHoursMessage : '';

    // Most type=URL or email do not have hours, they are always open
    const storeOpened =
        (contactType === 'url' || contactType === 'email') && !hoursCMS
            ? true
            : !!(hoursCMS?.afterHoursAvailability && hoursCMS.afterHoursAvailability === 'open');

    return [hoursCMS, afterHoursMessage, storeOpened];
};

export default calculateSchedules;
